export const RESTAURANT_POOL_DISABLED_TENANTS = ['at', 'be', 'bg', 'ch', 'de', 'dk', 'lu', 'nl', 'pl', 'sk']

const normalizeTenant = (tenant) => {
  const normalizedTenant = tenant.toLowerCase()

  if (normalizedTenant === 'gb') {
    return 'uk'
  }

  return normalizedTenant
}

export const isPoolRestaurantEditingDisabledForTenant = (tenant) => {
  if (!tenant) {
    return false
  }

  return RESTAURANT_POOL_DISABLED_TENANTS.includes(normalizeTenant(tenant))
}

export const canManageLegacyTakeawayPoolActions = (tenant, isMagicEnabled = false) => {
  if (isMagicEnabled) {
    return true
  }

  return !isPoolRestaurantEditingDisabledForTenant(tenant)
}

export const canEditPoolRestaurantsForTenant = (tenant, isMagicEnabled = false) => {
  return canManageLegacyTakeawayPoolActions(tenant, isMagicEnabled)
}

export const isMagicEnabledFromSearch = (search) => {
  if (!search) {
    return false
  }

  return /(?:^|[?&])magic(?:[=&]|$)/i.test(search)
}



// WEBPACK FOOTER //
// ./src/helpers/tenant.js